import { render, staticRenderFns } from "./BpsUserDataTable.vue?vue&type=template&id=b41edc12&"
import script from "./BpsUserDataTable.vue?vue&type=script&lang=js&"
export * from "./BpsUserDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports